import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '@ds';
import { CCSchedulerSettingsInputsFormType } from '@lp/features/Scheduler/SchedulerClinicalCoordinatorsSettings/types';
import { getNumberInputValue, getNumberInputValueHandler } from '@lp/features/Scheduler/utils';

export const CCSchedulerSettingsInputsForm = () => {
  const { control } = useFormContext<CCSchedulerSettingsInputsFormType>();

  return (
    <div className="flex flex-col gap-4 w-full p-6 bg-white rounded-2xl shadow-s">
      <span className="text-base-5 text-xl-sb">On Call amount per day</span>

      <div className="flex flex-col gap-4">
        <Controller
          name="onCallPerDay"
          control={control}
          render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => (
            <Input
              type="number"
              min={0}
              isInvalid={invalid}
              errorMessage={error?.message}
              className="w-[80px]"
              value={getNumberInputValue(value)}
              onValueChange={getNumberInputValueHandler(onChange)}
              {...field}
            />
          )}
        />
      </div>
    </div>
  );
};
